(() => {
  const init = root => root.querySelectorAll('[data-cos-gallery]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const content = gallery.querySelector('[data-gallery-content]');
    const pictures = [...content.querySelectorAll('img, video')];
    if (!pictures.length) return;
    const firstFigure = pictures[0].closest('figure');
    const grid = firstFigure ? firstFigure.parentElement : document.createElement('div');
    grid.classList.add('cos-gallery__grid');
    grid.removeAttribute('style');
    if (!firstFigure) { const anchor = pictures[0].closest('p') || pictures[0]; anchor.before(grid); }
    const dialog = gallery.querySelector('dialog');
    const stage = dialog.querySelector('.cos-gallery__stage');
    const close = dialog.querySelector('button');
    const caption = dialog.querySelector('.cos-gallery__caption');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let opener, scrollY, bodyStyle, closing = false;
    const videos = pictures.filter(media => media.tagName === 'VIDEO');
    const visibleVideos = new Set();
    const syncVideos = () => videos.forEach(video => {
      if (visibleVideos.has(video) && !document.hidden && !dialog.open) video.play().catch(()=>{});
      else video.pause();
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) visibleVideos.add(entry.target); else visibleVideos.delete(entry.target); });
      syncVideos();
    }, {threshold:.1});
    document.addEventListener('visibilitychange',syncVideos);
    gallery.addEventListener('pointerdown',syncVideos,{passive:true});
    const finish = () => {
      dialog.close();
      document.body.style.cssText = bodyStyle;
      window.scrollTo({top:scrollY,behavior:'instant'});
      opener?.focus({preventScroll:true});
      stage.replaceChildren();
      closing = false;
      syncVideos();
    };
    const dismiss = async () => {
      if (closing || !dialog.open) return;
      closing = true;
      const image = stage.querySelector('img, video');
      if (image?.tagName === 'VIDEO') image.pause();
      if (!reduced.matches && image && opener) {
        const from = image.getBoundingClientRect(), to = opener.getBoundingClientRect();
        const dx = to.x + to.width / 2 - from.x - from.width / 2;
        const dy = to.y + to.height / 2 - from.y - from.height / 2;
        await image.animate([{transform:'none',opacity:1},{transform:`translate(${dx}px,${dy}px) scale(${Math.min(to.width/from.width,to.height/from.height)})`,opacity:0}],{duration:220,easing:'ease-in',fill:'forwards'}).finished.catch(()=>{});
      }
      finish();
    };
    pictures.forEach((image,index) => {
      const isVideo = image.tagName === 'VIDEO';
      const description = image.alt || image.getAttribute('aria-label') || `Video ${index+1}`;
      let figure = image.closest('figure');
      if (!figure) { figure = document.createElement('figure'); image.before(figure); figure.append(image); }
      grid.append(figure);
      const oldLink = image.closest('a');
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'cos-gallery__tile';
      button.setAttribute('aria-label',`${gallery.querySelector('[data-gallery-open-label]').textContent}: ${description || index+1}`);
      button.setAttribute('aria-haspopup','dialog');
      if (oldLink) {oldLink.replaceWith(button);button.append(image);} else {image.replaceWith(button);button.append(image);}
      if (isVideo) {
        image.controls = false; image.preload = 'metadata'; image.playsInline = true; image.tabIndex = -1;
        image.muted = true; image.defaultMuted = true; image.autoplay = true; image.loop = true;
        image.setAttribute('muted',''); image.setAttribute('autoplay',''); image.setAttribute('loop',''); image.setAttribute('playsinline','');
        image.setAttribute('aria-hidden','true');
        observer.observe(image);
      } else {image.loading = index < 2 ? 'eager' : 'lazy'; image.decoding = 'async';}
      button.addEventListener('click', () => {
        opener = button; scrollY = window.scrollY; bodyStyle = document.body.style.cssText;
        const large = image.cloneNode(true); large.removeAttribute('style'); large.removeAttribute('width'); large.removeAttribute('height'); large.loading = 'eager';
        if (isVideo) { large.muted = true; large.loop = true; large.controls = true; large.preload = 'auto'; large.playsInline = true; large.removeAttribute('aria-hidden'); large.removeAttribute('tabindex'); }
        stage.replaceChildren(large); caption.textContent = description;
        document.body.style.position = 'fixed'; document.body.style.top = `-${scrollY}px`; document.body.style.width = '100%';
        dialog.showModal(); syncVideos(); close.focus({preventScroll:true});
        if (isVideo) large.play().catch(()=>{});
        if (!reduced.matches) large.animate([{transform:'scale(.92)',opacity:0},{transform:'scale(1)',opacity:1}],{duration:220,easing:'ease-out'});
      });
    });
    close.addEventListener('click',dismiss);
    dialog.addEventListener('cancel',event => {event.preventDefault();dismiss();});
    dialog.addEventListener('click',event => {if(event.target === dialog || event.target === stage) dismiss();});
  });
  init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
